<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    {{ 'users.newUser' | translate }}
  </div>
  <form class="ion-padding-bottom"
    [formGroup]="formGroup"
    (ngSubmit)="onSave()">
    <h6>{{ 'users.displayName' | translate }}</h6>
    <ion-item lines="none">
      <ion-input autocapitalize="on"
        formControlName="displayName"></ion-input>
    </ion-item>
    <h6>{{ 'register.form.email' | translate }}</h6>
    <ion-item lines="none">
      <ion-input formControlName="email"
        type="email"></ion-input>
    </ion-item>
    @if (canBeDummy()) {
      <h6>{{ 'register.form.phone' | translate }}</h6>
      <ion-item lines="none">
        <ion-input autocapitalize="on"
          formControlName="phone"
          type="tel"></ion-input>
      </ion-item>
    }
    @if (adminActionRoles.includes(userRoleS()) || contractorRoles.includes(userRoleS()) && roleS() == null) {
      <h6>{{ 'users.role' | translate }}</h6>
      <ion-item lines="none">
        <ion-select aria-label=""
          label-placement="stacked"
          [placeholder]="'general.select' | translate"
          class="full-width"
          interface="popover"
          formControlName="role">
          @for (role of roles(); track $index) {
            <ion-select-option [value]="role">
              {{ 'users.roles.' + role | translate }}
            </ion-select-option>
          }
        </ion-select>
      </ion-item>
    }
    @if (userRoleS() === 'super-admin') {
      @if (clients$ | async; as clients) {
        <ion-button (click)="selectClient(clients)">
          @if (formGroup.get('contractor').value; as contractor) {
            <span>
              {{ contractor.name }}
            </span>
          } @else {
            {{ 'subcontractor.select' | translate }}
          }
        </ion-button>
      }
    }
    @if (contractorRoles.includes(formGroup.value.role)) {
      <div class="ion-margin-top">
        <ion-checkbox aria-label=""
          color="light"
          disabled="true"
          labelPlacement="end"
          [checked]="true">
          {{ 'users.sendInviteInfo' | translate }}
        </ion-checkbox>
      </div>
    }
    <div class="ion-margin-top grid">
      <ion-button color="light"
        shape="round"
        type="submit"
        [disabled]="!formGroup.valid">{{ 'users.createUser' | translate }}</ion-button>
      @if (canBeDummy()) {
        <ion-button color="light"
          shape="round"
          [disabled]="!formGroup.valid"
          (click)="saveContact()">
          {{ 'users.onlyContact' | translate }}
        </ion-button>
      }
    </div>
  </form>
</app-main-dialog>